import { clamp, VERTICAL_LABEL_TARGET_WIDTH, LINE_HEIGHT } from '@shopify/polaris-viz-core';
import { truncateLabels } from './truncateLabels.js';

const QUARTER = 4;
function getVerticalLabels({
  labels,
  characterWidths,
  longestLabelWidth,
  targetWidth
}) {
  const clampedTargetWidth = clamp({
    amount: longestLabelWidth,
    min: targetWidth,
    max: VERTICAL_LABEL_TARGET_WIDTH
  });
  const truncatedLabels = truncateLabels({
    labels,
    targetWidth: clampedTargetWidth,
    targetHeight: LINE_HEIGHT,
    characterWidths,
    skipEndWordTruncate: true
  });
  const lines = [];
  let longestString = 0;

  for (let i = 0; i < labels.length; i++) {
    lines[i] = [];
    lines[i].push({
      truncatedText: truncatedLabels[i].truncatedName,
      fullText: truncatedLabels[i].text,
      y: LINE_HEIGHT / QUARTER,
      x: 0,
      width: clampedTargetWidth,
      height: LINE_HEIGHT,
      textAnchor: 'end',
      transform: `translate(${targetWidth / 2}) rotate(-90)`
    });

    if (truncatedLabels[i].truncatedWidth > longestString) {
      longestString = truncatedLabels[i].truncatedWidth;
    }
  }

  return {
    lines,
    containerHeight: longestString
  };
}

export { getVerticalLabels };
